import React from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { AvailableLanguages } from "@src/types";
import { plMessages } from "@src/intl/pl/pl";
import { enMessages } from "@src/intl/en/en";
import { deMessages } from "@src/intl/de/de";
import { enChapterMessages } from "@src/intl/en/chapters";
import { plChapterMessages } from "@src/intl/pl/chapters";
import { deChapterMessages } from "@src/intl/de/chapters";
import { enCourse01Chapter01Messages } from "@src/intl/en/chapter-01";
import { plCourse01Chapter01Messages } from "@src/intl/pl/chapter-01";
import { deCourse01Chapter01Messages } from "@src/intl/de/chapter-01";
import { enCourse01Chapter02Messages } from "@src/intl/en/chapter-02";
import { plCourse01Chapter02Messages } from "@src/intl/pl/chapter-02";
import { deCourse01Chapter02Messages } from "@src/intl/de/chapter-02";
import { enCourse01Chapter03Messages } from "@src/intl/en/chapter-03";
import { plCourse01Chapter03Messages } from "@src/intl/pl/chapter-03";
import { deCourse01Chapter03Messages } from "@src/intl/de/chapter-03";
import { enCourse01Chapter04Messages } from "@src/intl/en/chapter-04";
import { plCourse01Chapter04Messages } from "@src/intl/pl/chapter-04";
import { deCourse01Chapter04Messages } from "@src/intl/de/chapter-04";
import { enCourse01Chapter05Messages } from "@src/intl/en/chapter-05";
import { plCourse01Chapter05Messages } from "@src/intl/pl/chapter-05";
import { deCourse01Chapter05Messages } from "@src/intl/de/chapter-05";
import { enCourse01Chapter06Messages } from "@src/intl/en/chapter-06";
import { plCourse01Chapter06Messages } from "@src/intl/pl/chapter-06";
import { deCourse01Chapter06Messages } from "@src/intl/de/chapter-06";
import { enCourse01Chapter07Messages } from "@src/intl/en/chapter-07";
import { plCourse01Chapter07Messages } from "@src/intl/pl/chapter-07";
import { deCourse01Chapter07Messages } from "@src/intl/de/chapter-07";
import { enCase01Messages } from "@src/intl/en/case-01";
import { plCase01Messages } from "@src/intl/pl/case-01";
import { deCase01Messages } from "@src/intl/de/case-01";
import { enCase02Messages } from "@src/intl/en/case-02";
import { plCase02Messages } from "@src/intl/pl/case-02";
import { deCase02Messages } from "@src/intl/de/case-02";
import { enCase03Messages } from "@src/intl/en/case-03";
import { plCase03Messages } from "@src/intl/pl/case-03";
import { deCase03Messages } from "@src/intl/de/case-03";
import { enCase04Messages } from "@src/intl/en/case-04";
import { plCase04Messages } from "@src/intl/pl/case-04";
import { deCase04Messages } from "@src/intl/de/case-04";
import { enCase05Messages } from "@src/intl/en/case-05";
import { plCase05Messages } from "@src/intl/pl/case-05";
import { deCase05Messages } from "@src/intl/de/case-05";
import { enCase06Messages } from "@src/intl/en/case-06";
import { plCase06Messages } from "@src/intl/pl/case-06";
import { deCase06Messages } from "@src/intl/de/case-06";
import { enCase07Messages } from "@src/intl/en/case-07";
import { plCase07Messages } from "@src/intl/pl/case-07";
import { deCase07Messages } from "@src/intl/de/case-07";
import { enCase08Messages } from "@src/intl/en/case-08";
import { plCase08Messages } from "@src/intl/pl/case-08";
import { deCase08Messages } from "@src/intl/de/case-08";
import { enGuide02Messages } from "@src/intl/en/guide-02";
import { plGuide02Messages } from "@src/intl/pl/guide-02";
import { deGuide02Messages } from "@src/intl/de/guide-02";
import { enGuide03Messages } from "@src/intl/en/guide-03";
import { plGuide03Messages } from "@src/intl/pl/guide-03";
import { deGuide03Messages } from "@src/intl/de/guide-03";
import { enGuide04Messages } from "@src/intl/en/guide-04";
import { plGuide04Messages } from "@src/intl/pl/guide-04";
import { deGuide04Messages } from "@src/intl/de/guide-04";
import { enGuide05Messages } from "@src/intl/en/guide-05";
import { plGuide05Messages } from "@src/intl/pl/guide-05";
import { deGuide05Messages } from "@src/intl/de/guide-05";
import { enGuide06Messages } from "@src/intl/en/guide-06";
import { plGuide06Messages } from "@src/intl/pl/guide-06";
import { deGuide06Messages } from "@src/intl/de/guide-06";
import { enGuide07Messages } from "@src/intl/en/guide-07";
import { plGuide07Messages } from "@src/intl/pl/guide-07";
import { deGuide07Messages } from "@src/intl/de/guide-07";
import { enTeamMessages } from "@src/intl/en/team";
import { plTeamMessages } from "@src/intl/pl/team";
import { deTeamMessages } from "@src/intl/de/team";

interface IntlProviderProps {
  locale: AvailableLanguages;
  children: React.ReactNode;
}

export const IntlProvider: React.FC<IntlProviderProps> = ({ locale, children }) => {
  const i18nMessages: Record<AvailableLanguages, Record<string, string>> = {
    pl: {
      ...plMessages,
      ...plCourse01Chapter01Messages,
      ...plCourse01Chapter02Messages,
      ...plCourse01Chapter03Messages,
      ...plCourse01Chapter04Messages,
      ...plCourse01Chapter05Messages,
      ...plCourse01Chapter06Messages,
      ...plCourse01Chapter07Messages,
      ...plCase01Messages,
      ...plCase02Messages,
      ...plCase03Messages,
      ...plCase04Messages,
      ...plCase05Messages,
      ...plCase06Messages,
      ...plCase07Messages,
      ...plCase08Messages,
      ...plChapterMessages,
      ...plGuide02Messages,
      ...plGuide03Messages,
      ...plGuide04Messages,
      ...plGuide05Messages,
      ...plGuide06Messages,
      ...plGuide07Messages,
      ...plTeamMessages,
    },
    en: {
      ...enMessages,
      ...enCourse01Chapter01Messages,
      ...enCourse01Chapter02Messages,
      ...enCourse01Chapter03Messages,
      ...enCourse01Chapter04Messages,
      ...enCourse01Chapter05Messages,
      ...enCourse01Chapter06Messages,
      ...enCourse01Chapter07Messages,
      ...enCase01Messages,
      ...enCase02Messages,
      ...enCase03Messages,
      ...enCase04Messages,
      ...enCase05Messages,
      ...enCase06Messages,
      ...enCase07Messages,
      ...enCase08Messages,
      ...enChapterMessages,
      ...enGuide02Messages,
      ...enGuide03Messages,
      ...enGuide04Messages,
      ...enGuide05Messages,
      ...enGuide06Messages,
      ...enGuide07Messages,
      ...enTeamMessages,
    },
    de: {
      ...deMessages,
      ...deCourse01Chapter01Messages,
      ...deCourse01Chapter02Messages,
      ...deCourse01Chapter03Messages,
      ...deCourse01Chapter04Messages,
      ...deCourse01Chapter05Messages,
      ...deCourse01Chapter06Messages,
      ...deCourse01Chapter07Messages,
      ...deCase01Messages,
      ...deCase02Messages,
      ...deCase03Messages,
      ...deCase04Messages,
      ...deCase05Messages,
      ...deCase06Messages,
      ...deCase07Messages,
      ...deCase08Messages,
      ...deChapterMessages,
      ...deGuide02Messages,
      ...deGuide03Messages,
      ...deGuide04Messages,
      ...deGuide05Messages,
      ...deGuide06Messages,
      ...deGuide07Messages,
      ...deTeamMessages,
    },
  };

  return (
    <ReactIntlProvider locale={locale} messages={i18nMessages[locale]}>
      {children}
    </ReactIntlProvider>
  );
};
